import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { API } from '../App';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';
import MaintenanceHistoryView from '../components/MaintenanceHistoryView';
import HeaderMenu from '../components/HeaderMenu';

const LocationMaintenanceLogs = ({ user, onLogout }) => {
  const { locationId } = useParams();
  const navigate = useNavigate();
  const [location, setLocation] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/locations/${locationId}`)
      .then((res) => setLocation(res.data))
      .catch((e) => {
        toast.error(e.response?.data?.detail || 'Failed to load location');
        navigate('/');
      })
      .finally(() => setLoading(false));
  }, [locationId, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <p className="text-slate-600">Loading…</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="bg-white border-b shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex flex-wrap justify-between items-center gap-2">
            <Button
              variant="outline"
              onClick={() => navigate(`/location/${locationId}`)}
              data-testid="back-to-equipment-btn"
              className="h-auto min-h-10 max-w-full whitespace-normal break-words text-left"
            >
              ← Back to {location?.name} Equipment
            </Button>
            <Button variant="outline" onClick={onLogout} data-testid="logout-btn">
              Logout
            </Button>
            <HeaderMenu user={user} onLogout={onLogout} />
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <MaintenanceHistoryView
          locationId={locationId}
          user={user}
          title={`Maintenance History — ${location?.name || ''}`}
          subtitle="Logs, completed work orders, and completed maintenance requests for this plant."
        />
      </div>
    </div>
  );
};

export default LocationMaintenanceLogs;
